import { render, staticRenderFns } from "./MpcForm.vue?vue&type=template&id=b9bc581e&"
import script from "./MpcForm.vue?vue&type=script&lang=js&"
export * from "./MpcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports